module.exports = __webpack_public_path__ + "/img/ChipArray-4side-FlatConcave-ccgLhv.svg";